// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-config-detail {
  display: block;
}

.wm-config-detail {
  margin: var(--wm-feature-details-margin);
}
.wm-config-detail > *:last-child {
  margin-bottom: 0;
}

.wm-config-detail-item {
  border: 1px solid var(--ion-color-light-shade, #e2e8f0);
  border-radius: 8px;
  margin-bottom: 12px;
  overflow: hidden;
  transition: border-color 0.2s ease;
}
.wm-config-detail-item--open {
  border-color: var(--wm-color-primary, #3880ff);
}
.wm-config-detail-item--group-start {
  margin-top: 40px;
}

.wm-config-detail-toggle-button {
  display: block;
  width: 100%;
  min-height: 44px;
  margin-top: 16px;
  margin-bottom: 12px;
  padding: 12px 16px;
  background: var(--wm-color-primary, #3880ff);
  border: none;
  border-radius: 8px;
  color: var(--wm-color-primary-contrast, #ffffff);
  font: inherit;
  font-weight: 700;
  text-transform: uppercase;
  text-align: center;
  cursor: pointer;
  transition: opacity 0.2s ease;
}
.wm-config-detail-toggle-button:active {
  opacity: 0.8;
}

.wm-config-detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  min-height: 44px;
  padding: 12px 16px;
  background: #ffffff;
  border: none;
  cursor: pointer;
  font: inherit;
  text-align: left;
}

.wm-config-detail-title {
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.9rem;
}

.wm-config-detail-chevron {
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 8px;
  background: #1a1a1a;
  display: flex;
  align-items: center;
  justify-content: center;
}
.wm-config-detail-chevron ion-icon {
  color: #ffffff;
  transition: transform 0.2s ease;
}

.wm-config-detail-item--open .wm-config-detail-chevron {
  background: var(--wm-color-primary, #3880ff);
}

.wm-config-detail-item--open .wm-config-detail-chevron ion-icon {
  transform: rotate(90deg);
}

.wm-config-detail-content-wrapper {
  display: grid;
  grid-template-rows: 0fr;
  overflow: hidden;
  transition: grid-template-rows 0.3s ease;
}

.wm-config-detail-item--open .wm-config-detail-content-wrapper {
  grid-template-rows: 1fr;
}

.wm-config-detail-content {
  min-height: 0;
  overflow: hidden;
  padding: 0 16px 16px;
  font-size: 0.95rem;
}
.wm-config-detail-content img {
  max-width: 100%;
}
.wm-config-detail-content iframe {
  max-width: 100%;
  width: 100%;
  height: auto;
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/config-detail/config-detail.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EAOE,wCAAA;AALF;AAYE;EACE,gBAAA;AAVJ;;AAcA;EACE,uDAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kCAAA;AAXF;AAaE;EACE,8CAAA;AAXJ;AAcE;EAKE,gBAAA;AAhBJ;;AAoBA;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EAIA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,4CAAA;EACA,YAAA;EACA,kBAAA;EACA,gDAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;AApBF;AAsBE;EACE,YAAA;AApBJ;;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;AArBF;;AAwBA;EACE,gBAAA;EACA,yBAAA;EACA,iBAAA;AArBF;;AAwBA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AArBF;AAuBE;EACE,cAAA;EACA,+BAAA;AArBJ;;AAyBA;EACE,4CAAA;AAtBF;;AAyBA;EACE,wBAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,wCAAA;AAtBF;;AAyBA;EACE,uBAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;AAtBF;AAwBE;EACE,eAAA;AAtBJ;AAyBE;EAME,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AA5BJ","sourcesContent":["wm-config-detail {\n  display: block;\n}\n\n.wm-config-detail {\n  // Margine sul wrapper interno (gated da `*ngIf=\"visibleEntries.length\"` nel template), non sul\n  // tag host `wm-config-detail`: il tag host è sempre nel DOM nei 3 consumer (nessun `*ngIf`\n  // esterno, per design — vedi overview, \"singolo binding senza logica di branching\"). Se il\n  // margine vivesse sul tag host, un `config_detail` assente/vuoto lascerebbe comunque uno\n  // spazio vuoto visibile (margin di un box a contenuto zero, non collassato), contro il\n  // requisito esplicito \"nessun cambiamento visibile\" (bug trovato in wm-skills:wm-review-ticket).\n  margin: var(--wm-feature-details-margin);\n\n  // Azzera il margin-bottom finale solo sull'ultimo figlio REALE del componente (item o pulsante\n  // \"Mostra altro\"/\"Mostra meno\", qualunque sia), non su \".wm-config-detail-item:last-of-type\" —\n  // quella regola avrebbe azzerato il gap tra l'ultimo item mostrato e il pulsante che lo segue\n  // (\":last-of-type\" si applica all'ultimo elemento di quel tipo, indipendentemente da cosa lo\n  // segue), incollandoli visivamente.\n  > *:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.wm-config-detail-item {\n  border: 1px solid var(--ion-color-light-shade, #e2e8f0);\n  border-radius: 8px;\n  margin-bottom: 12px;\n  overflow: hidden;\n  transition: border-color 0.2s ease;\n\n  &--open {\n    border-color: var(--wm-color-primary, #3880ff);\n  }\n\n  &--group-start {\n    // Nessuna intestazione visibile tra un gruppo e l'altro, ma serve più spazio del semplice\n    // gap tra item dello stesso gruppo (fedele al sito di riferimento) — i margini verticali tra\n    // box adiacenti collassano al valore più alto, quindi basta questo per ottenere un gap\n    // complessivo maggiore rispetto ai 12px di margin-bottom tra item dello stesso gruppo.\n    margin-top: 40px;\n  }\n}\n\n.wm-config-detail-toggle-button {\n  display: block;\n  width: 100%;\n  min-height: 44px;\n  // Più dei 12px di gap tra item dello stesso gruppo: deve essere STRETTAMENTE maggiore di 12px,\n  // perché i margini adiacenti collassano al valore più alto (non si sommano) — un valore pari o\n  // inferiore a margin-bottom:12px dell'item precedente non avrebbe alcun effetto visibile.\n  margin-top: 16px;\n  margin-bottom: 12px;\n  padding: 12px 16px;\n  background: var(--wm-color-primary, #3880ff);\n  border: none;\n  border-radius: 8px;\n  color: var(--wm-color-primary-contrast, #ffffff);\n  font: inherit;\n  font-weight: 700;\n  text-transform: uppercase;\n  text-align: center;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n\n  &:active {\n    opacity: 0.8;\n  }\n}\n\n.wm-config-detail-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  min-height: 44px;\n  padding: 12px 16px;\n  background: #ffffff;\n  border: none;\n  cursor: pointer;\n  font: inherit;\n  text-align: left;\n}\n\n.wm-config-detail-title {\n  font-weight: 700;\n  text-transform: uppercase;\n  font-size: 0.9rem;\n}\n\n.wm-config-detail-chevron {\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n  border-radius: 8px;\n  background: #1a1a1a;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  ion-icon {\n    color: #ffffff;\n    transition: transform 0.2s ease;\n  }\n}\n\n.wm-config-detail-item--open .wm-config-detail-chevron {\n  background: var(--wm-color-primary, #3880ff);\n}\n\n.wm-config-detail-item--open .wm-config-detail-chevron ion-icon {\n  transform: rotate(90deg);\n}\n\n.wm-config-detail-content-wrapper {\n  display: grid;\n  grid-template-rows: 0fr;\n  overflow: hidden;\n  transition: grid-template-rows 0.3s ease;\n}\n\n.wm-config-detail-item--open .wm-config-detail-content-wrapper {\n  grid-template-rows: 1fr;\n}\n\n.wm-config-detail-content {\n  min-height: 0;\n  overflow: hidden;\n  padding: 0 16px 16px;\n  font-size: 0.95rem;\n\n  img {\n    max-width: 100%;\n  }\n\n  iframe {\n    // Nessun aspect-ratio forzato: il markup embed del backend porta sempre width/height HTML\n    // reali (es. 560x315 per un video 16:9, ma anche 600x450 = 4:3 per una mappa) — forzare 16/9\n    // avrebbe distorto/compresso qualunque embed che non fosse un video in quel rapporto. Con\n    // solo width:100%;height:auto il browser deriva il rapporto naturale dagli attributi\n    // width/height dell'iframe, stesso meccanismo già usato per `img` qui sopra.\n    max-width: 100%;\n    width: 100%;\n    height: auto;\n    border: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
